import { all } from 'redux-saga/effects'

import formSaga from './components/EditProfileForm/saga'

export default function* generalSettingsSaga() {
    yield all([formSaga()])
}
